/* src/app/module/service-provider/add-sp-new-component/payment/payment.component.scss */
.box {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 16px;
  margin-bottom: 16px;
}
.payment {
  font-size: 24px;
  font-weight: bold;
  color: black;
  margin-bottom: 16px;
  margin-top: 8px;
}
.details {
  font-size: 18px;
  font-weight: 500;
  color: #666666;
}
.plan-icon {
  width: 30px;
  height: 30px;
  background-color: #ffe8cc;
  border: 2px solid #fff1e0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.plan-details {
  margin-left: 20px;
  flex-grow: 1;
  font-size: 16px;
  font-weight: 500;
}
.plan-price {
  font-size: 16px;
  font-weight: 500;
  color: #344054;
}
.supporting-text {
  font-size: 14px;
  color: #666666;
  margin-bottom: 16px;
}
.payment-methods {
  margin-top: 24px;
}
.payment-methods label {
  font-size: 16px;
  color: #344054;
}
.payment-methods input[type=radio] {
  margin-right: 16px;
}
.btn-primary {
  background-color: #FF8C00;
  color: white;
  font-size: 16px;
  font-weight: 600;
  padding: 10px 24px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-primary:disabled,
.btn-primary.disabled {
  background-color: #e0e0e0;
  color: #9e9e9e;
  cursor: not-allowed;
}
.btn-primary:disabled .arrow-icon {
  display: none;
}
.btn-primary .arrow-icon {
  margin-left: 8px;
  font-size: 16px;
}
.hr {
  border: 0;
  height: 1px;
  background: #e5e7eb;
  margin: 16px 0;
}
.amount-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 10px;
}
.amount-row {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 28px;
}
.label {
  min-width: 100px;
  text-align: right;
  margin-right: 10px;
}
.value {
  min-width: 70px;
  text-align: right;
  font-weight: 500;
}
.total {
  font-weight: bold;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(8, 12, 20, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.spinner-bar {
  width: 100px;
  height: 10px;
  background-color: black;
  animation: load 2s infinite;
}
@keyframes load {
  0% {
    width: 0;
  }
  100% {
    width: 100px;
  }
}
form {
  width: 676px;
}
/*# sourceMappingURL=payment.component-G5SGETLA.css.map */
